import { render } from "./PartnersByClassificationChart.vue?vue&type=template&id=ec9f940e&scoped=true"
import script from "./PartnersByClassificationChart.vue?vue&type=script&lang=js"
export * from "./PartnersByClassificationChart.vue?vue&type=script&lang=js"

import "./PartnersByClassificationChart.vue?vue&type=style&index=0&id=ec9f940e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ec9f940e"

export default script